module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"defaultTitle":"Відповіді на деякі важливі запитання"},"en":{"defaultTitle":"Answers to some important questions"}}')
  delete Component.options._Ctor
}
